import styled from 'styled-components'

export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 0;
`
export const TableWrapper = styled.div`
`